import React from 'react';

import axios from 'axios';

import {
  NavLink,
  Outlet,
  useNavigate,
} from 'react-router-dom';

import './AdminLayout.css';

/* global process */

const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL;

const AdminLayout = ({
  adminUser,
  setAdminUser,
}) => {
  const navigate =
    useNavigate();

  const clearCsrfHeaders = () => {
    delete axios.defaults.headers.post[
      'X-CSRF-Token'
    ];

    delete axios.defaults.headers.put[
      'X-CSRF-Token'
    ];

    delete axios.defaults.headers.patch[
      'X-CSRF-Token'
    ];

    delete axios.defaults.headers.delete[
      'X-CSRF-Token'
    ];
  };

  const handleLogout = async () => {
    try {
      await axios.delete(
        `${API_BASE_URL}/api/v1/admin/session`,
        {
          withCredentials: true,
        }
      );
    } catch (requestError) {
      console.error(
        'ACE admin sign-out error:',
        requestError
      );
    } finally {
      clearCsrfHeaders();

      setAdminUser(null);

      navigate(
        '/admin/login',
        {
          replace: true,
        }
      );
    }
  };

  return (
    <div className="ace-admin">
      <aside className="admin-sidebar">
        <div className="admin-brand">
          <span className="admin-brand-mark">
            ACE
          </span>

          <div>
            <strong>
              Administration
            </strong>

            <small>
              Digital workspace
            </small>
          </div>
        </div>

        <div className="admin-user">
          <span>
            Signed in as
          </span>

          <strong>
            {adminUser?.name ||
             adminUser?.email ||
             'Administrator'}
          </strong>

          <small>
            {adminUser?.status ||
             'Administrator'}
          </small>
        </div>

        <nav className="admin-nav">
          <NavLink
            to="/admin"
            end
            className={({ isActive }) =>
              isActive ? 'active' : ''
            }
          >
            Dashboard
          </NavLink>

          <NavLink
            to="/admin/opportunities"
            className={({ isActive }) =>
              isActive ? 'active' : ''
            }
          >
            Opportunities
          </NavLink>

          <NavLink
            to="/admin/results-framework"
            className={({ isActive }) =>
              isActive ? 'active' : ''
            }
          >
            Results Framework
          </NavLink>

          <NavLink
            to="/admin/programme-content"
            className={({ isActive }) =>
              isActive ? 'active' : ''
            }
          >
            Programme Content
          </NavLink>

          <NavLink
            to="/admin/opportunity-sources"
            className={({ isActive }) =>
              isActive ? 'active' : ''
            }
          >
            Sources
          </NavLink>

          <NavLink
            to="/admin/partnership-enquiries"
            className={({ isActive }) =>
              isActive ? 'active' : ''
            }
          >
            Partnership Enquiries
          </NavLink>
        </nav>

        <div className="admin-sidebar-footer">
          <NavLink
            to="/"
          >
            ← Public website
          </NavLink>

          <button
            type="button"
            className="admin-logout"
            onClick={handleLogout}
          >
            Sign out
          </button>
        </div>
      </aside>

      <section className="admin-workspace">
        <Outlet />
      </section>
    </div>
  );
};

export default AdminLayout;
